import Cookies from 'js-cookie'

const TokenKey = 'loginToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function isMenus(n,menus) {
  var b=false;
  for(let i in menus){
    if(menus[i].name==n){
      b=true;
      break;
    }
  }
  return  b;
}




// WEBPACK FOOTER //
// ./src/utils/auth.js